export default "__VITE_ASSET__d7ff6146__"